import React from "react";
import {createBlock} from "@wordpress/blocks";
import {registerPlugin} from "@wordpress/plugins";
import {dispatch, select, useSelect} from "@wordpress/data";
import {PluginSidebarMoreMenuItem, PluginSidebar} from "@wordpress/editor";
import {Fragment} from "@wordpress/element";
import {page} from "@wordpress/icons";
import {PanelBody, Button, Modal} from "@wordpress/components";

const PageStarterRender = () => {
    const currentBlocks = useSelect((select) => select('core/block-editor').getBlocks());
    const currentPostType = useSelect((select) => select('core/editor').getCurrentPostType());
    const [showConfirmModal, setShowConfirmModal] = React.useState(false);
    const [pendingTemplate, setPendingTemplate] = React.useState(null);
    const [hasOpenedStarter, setHasOpenedStarter] = React.useState(false);
    const [hasOpenedSettings, setHasOpenedSettings] = React.useState(false);

    // Open page starter sidebar on new pages
    React.useEffect(() => {
        if (currentPostType === 'page' && currentBlocks.length === 0 && !hasOpenedStarter) {
            // Small delay to ensure sidebar is ready
            setTimeout(() => {
                dispatch('core/edit-post').openGeneralSidebar('template-scripts-page-starter/page-starter');
                setHasOpenedStarter(true);
            }, 100);
        }
    }, [currentPostType, currentBlocks.length, hasOpenedStarter]);

    // Open settings pane if page already has blocks
    React.useEffect(() => {
        if (currentPostType === 'page' && currentBlocks.length > 0 && !hasOpenedSettings && !hasOpenedStarter) {
            // Small delay to ensure sidebar is ready
            setTimeout(() => {
                dispatch('core/edit-post').openGeneralSidebar('edit-post/document');
                setHasOpenedSettings(true);
            }, 100);
        }
    }, [currentPostType, currentBlocks.length, hasOpenedSettings, hasOpenedStarter]);

    // Define your page starter templates here
    // Each template should be an array of blocks created with createBlock()

    const pageSections = [
        {
            name:"3 Column Icon/Text",
            blocks:[
                createBlock("template-scripts/section-holder", {width: 'narrow'}, [
                    createBlock("core/columns", {}, [
                        createBlock("core/column", {}, [
                            createBlock("template-scripts/icon-text-block", {
                                textAlign:"left",
                                icon:"diamond-outline"
                            }, []),
                        ]),
                        createBlock("core/column", {}, [
                            createBlock("template-scripts/icon-text-block", {
                                textAlign:"left",
                                icon:"diamond-outline"
                            }, []),
                        ]),
                        createBlock("core/column", {}, [
                            createBlock("template-scripts/icon-text-block", {
                                textAlign:"left",
                                icon:"diamond-outline"
                            }, []),
                        ]),
                    ])
                ])
            ]
        },
        {
            name:"Left Photos/Right Text",
            blocks:[
                createBlock("template-scripts/section-holder", {width: 'narrow'}, [
                    createBlock("template-scripts/photo-text-section", {
                        backgroundColor: "#fcfcfc",
                        backgroundName:"Transparent",
                        image:{url:"https://placehold.co/1200x1600",id:"123"},
                        image2:{url:"https://placehold.co/600x600",id:"123"}
                    },[
                        createBlock("template-scripts/section-header", {textAlign: "left",mainText:"Heading",subText:"Subheader",textColor:"#000"}, []),
                        createBlock("core/paragraph", {content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",color:"#000"}, []),
                        createBlock("core/paragraph", {color:"#000"}, []),
                        createBlock("template-scripts/button", {
                            align: "left",    
                            backgroundColor:"#00a2af",
                            fontColor:"#fff"
                        }, [])
                        ]
                )
                ])
            ]
        },
        {
            name:"Large Hero Text",
            blocks:[
                createBlock("template-scripts/section-holder", {width: 'narrow'}, [
                    createBlock("template-scripts/hero", {
                        headline:"Large Hero Text",
                        subheadline:"Subheadline",
                        buttonText:"Button Text",
                        buttonLink:"#"
                    }, [])
                ])
            ]
        }
    ]


    const pageTemplates = [
        {
            name: "Default Starter",
            blocks: [
                
                createBlock("template-scripts/section-holder", {width: 'narrow'}, [
                    createBlock("template-scripts/photo-text-section", {
                        backgroundColor: "#fcfcfc",
                        backgroundName:"Transparent",
                        image:{url:"https://placehold.co/1200x1600",id:"123"},
                        image2:{url:"https://placehold.co/600x600",id:"123"}
                    }, [
                    createBlock("template-scripts/section-header", {textAlign: "left",mainText:"Heading",subText:"Subheader",textColor:"#000"}, []),
                    createBlock("core/paragraph", {content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",color:"#000"}, []),
                    createBlock("core/paragraph", {color:"#000"}, []),
                    createBlock("template-scripts/button", {
                        align: "left",    
                        backgroundColor:"#00a2af",
                        fontColor:"#fff"
                    }, [])
                    ])
                ])
            
            ]
        },
        {
            name: "Case Studies",
            blocks: [
                
                createBlock("template-scripts/section-holder", {width: 'narrow'}, [
                    createBlock("template-scripts/image-slide", {
                        image:{url:"https://placehold.co/1600x800",id:"123"},
                    })
                ]),



                createBlock("template-scripts/section-holder", {width: 'narrower'}, [
                    createBlock("template-scripts/tabbed-content", {
                        slideDetails:[
                            {
                                "title":"Challenge",
                                content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                            },
                            {
                                "title":"Strategy",
                                content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                            },
                            {
                                "title":"Results",
                                content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                            }
                        ]
                    })
                ]),
                createBlock("template-scripts/section-holder", {width: 'narrow'}, [
                    createBlock("core/image", {
                        url:"https://placehold.co/1600x1200",
                        id:"123"
                    })
                ]),
                createBlock("template-scripts/section-holder", {width: 'narrow'}, [
                    createBlock("core/columns", {}, [
                        createBlock("core/column", {},[
                            createBlock("core/image", {
                                url:"https://placehold.co/1200x1200",
                                id:"123"
                            })
                        ]),
                        createBlock("core/column", {},[
                            createBlock("core/image", {
                                url:"https://placehold.co/1200x1200",
                                id:"123"
                            })
                        ])
                    ]),
                ]),
                createBlock("template-scripts/section-holder", {width: 'narrow'}, [
                    createBlock("core/image", {
                        url:"https://placehold.co/1600x1200",
                        id:"123"
                    })
                ]),
                
            
            ]
        },
        // Add more templates here as needed
        // Example:
        // {
        //     name: "Two Column Layout",
        //     blocks: [
        //         createBlock('template-scripts/section-holder', {
        //             backgroundColor: '#fcfcfc'
        //         }, [
        //             createBlock("core/columns", {}, [
        //                 createBlock("core/column", {}, [
        //                     createBlock("core/image", {}, []),
        //                 ]),
        //                 createBlock("core/column", {}, [
        //                     createBlock("template-scripts/section-header", {textAlign: "left"}, []),
        //                     createBlock("core/paragraph", {}, []),
        //                     createBlock("template-scripts/button", {align: "left"}, []),
        //                 ]),
        //             ])
        //         ])
        //     ]
        // }
    ];

    const applyTemplate = (template) => {
        // Check if page already has blocks
        if (currentBlocks && currentBlocks.length > 0) {
            // Show confirmation modal
            setPendingTemplate(template);
            setShowConfirmModal(true);
        } else {
            // No blocks exist, apply template directly
            applyTemplateBlocks(template);
        }
    };

    const applyTemplateBlocks = (template) => {
        // Get fresh current blocks
        const blocks = select('core/block-editor').getBlocks();
        const blockClientIds = blocks.map(block => block.clientId);
        
        if (blockClientIds.length > 0) {
            // Replace existing blocks
            dispatch('core/block-editor').replaceBlocks(blockClientIds, template.blocks);
        } else {
            // No blocks exist, just insert the template blocks
            template.blocks.forEach(block => {
                dispatch('core/block-editor').insertBlock(block);
            });
        }
        
        // Close page starter sidebar and open page settings sidebar
        dispatch('core/edit-post').closeGeneralSidebar();
        setTimeout(() => {
            // Open the document sidebar (shows page settings)
            dispatch('core/edit-post').openGeneralSidebar('edit-post/document');
        }, 150);
        
        setShowConfirmModal(false);
        setPendingTemplate(null);
    };

    const handleConfirm = () => {
        if (pendingTemplate) {
            applyTemplateBlocks(pendingTemplate);
        }
    };

    const handleCancel = () => {
        setShowConfirmModal(false);
        setPendingTemplate(null);
    };

    const applySection = (section) => {
        // Append section blocks to the end of the page
        section.blocks.forEach(block => {
            // Insert at undefined index to append to the end
            dispatch('core/block-editor').insertBlock(block);
        });
    };

    return (
        <>
            <PluginSidebarMoreMenuItem target="page-starter">
                Page Starter
            </PluginSidebarMoreMenuItem>
            <PluginSidebar name="page-starter" title="Page Starter Templates">
                <div className="pageStarter" style={{padding: "16px"}}>
                    <PanelBody title="Full Page Templates" initialOpen={true}>
                        {pageTemplates.length === 0 ? (
                            <p>No templates defined. Add templates in the code.</p>
                        ) : (
                            pageTemplates.map((template, index) => (
                                <Button
                                    key={index}
                                    variant="secondary"
                                    onClick={() => applyTemplate(template)}
                                    style={{
                                        width: "100%",
                                        marginBottom: "8px",
                                        justifyContent: "flex-start"
                                    }}
                                >
                                    {template.name}
                                </Button>
                            ))
                        )}
                    </PanelBody>
                    <PanelBody title="Page Sections" initialOpen={true}>
                        {pageSections.length === 0 ? (
                            <p>No sections defined. Add sections in the code.</p>
                        ) : (
                            pageSections.map((section, index) => (
                                <Button key={index} variant="secondary"  style={{
                                    width: "100%",
                                    marginBottom: "8px",
                                    justifyContent: "flex-start"
                                }} onClick={() => applySection(section)}>{section.name}</Button>
                            ))
                        )}
                    </PanelBody>
                </div>
            </PluginSidebar>

            {showConfirmModal && (
                <Modal
                    title="Replace Page Content?"
                    onRequestClose={handleCancel}
                    style={{maxWidth: "400px"}}
                >
                    <p>
                        This page already contains content. Applying this template will replace all existing blocks.
                        Are you sure you want to continue?
                    </p>
                    <div style={{display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "16px"}}>
                        <Button variant="secondary" onClick={handleCancel}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={handleConfirm}>
                            Replace Content
                        </Button>
                    </div>
                </Modal>
            )}
        </>
    );
};

registerPlugin('template-scripts-page-starter', {
    icon: page,
    render: PageStarterRender
});

